import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
	.set('Search' , new Immutable.List([]))
	.set('plantilla' , new Immutable.List([]))
	.set('envio' , new Immutable.List([]))
	.set('donataria' , new Immutable.List([]))
	.set('donante' , new Immutable.List([]))
	.set('organismo' , new Immutable.List([]))
	.set('consultor' , new Immutable.List([]))
	.set('corrida' , new Immutable.List([]))
	.set('grupo' , new Immutable.List([]))
	.set('estado' , new Immutable.List([]))
	.set('catalogo' , new Immutable.List([]))
	.set('estadoApp' , new Immutable.List([]))
	.set('estadoPago' , new Immutable.List([]))
	.set('imprimir', new Immutable.Map({}))
	.set('enviar', new Immutable.Map({}))
	.set('corridas', new Immutable.List([]))
	.set('Uid', new Immutable.Map({}))
	.set('Socket', new Immutable.Map({}))

/* Types */
export const ACTION_TIPOS_NOTIFICATION = 'ACTION_TIPOS_NOTIFICATION'
export const ACTION_PLANTILLAS = 'ACTION_PLANTILLAS'
export const ACTION_TIPOS_ENVIO = 'ACTION_TIPOS_ENVIO'
export const ACTION_DONATARIA_NOTIFICACION = 'ACTION_DONATARIA_NOTIFICACION'
export const ACTION_DONANTE_NOTIFICACION = 'ACTION_DONANTE_NOTIFICACION'
export const ACTION_ORGANISMOREG_NOTIFICACION = 'ACTION_ORGANISMOREG_NOTIFICACION'
export const ACTION_CONSULTOR_NOTIFICACION = 'ACTION_CONSULTOR_NOTIFICACION'
export const ACTION_CORRIDA_NOTIFICACION = 'ACTION_CORRIDA_NOTIFICACION'
export const ACTION_GRUPO_NOTIFICACION = 'ACTION_GRUPO_NOTIFICACION'
export const ACTION_ESTADODON_NOTIFICACION = 'ACTION_ESTADODON_NOTIFICACION'
export const ACTION_CATALOGORES_NOTIFICACION = 'ACTION_CATALOGORES_NOTIFICACION'
export const ACTION_ESTAPP_NOTIFICACION = 'ACTION_ESTAPP_NOTIFICACION'
export const ACTION_ESTPAGO_NOTIFICACION = 'ACTION_ESTPAGO_NOTIFICACION'
export const ACTION_IMPRIMIR_NOTIFICACION = 'ACTION_IMPRIMIR_NOTIFICACION'
export const ACTION_ENVIAR_NOTIFICACION = "ACTION_ENVIAR_NOTIFICACION"
export const ACTION_CORRIDAS_DONATARIA = "ACTION_CORRIDAS_DONATARIA"
export const ACTION_PRINT_NOTIFICATION = "ACTION_PRINT_NOTIFICATION"

/* Reducer*/
export default (state = initialState, action) => {

	switch(action.type) {
		case ACTION_TIPOS_NOTIFICATION:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_PLANTILLAS:
			return state.set('plantilla', new Immutable.List(action.Obj))
		case ACTION_TIPOS_ENVIO:
			return state.set('envio', new Immutable.List(action.Obj))
		case ACTION_DONATARIA_NOTIFICACION:
			return state.set('donataria', new Immutable.List(action.Obj))
		case ACTION_DONANTE_NOTIFICACION:
			return state.set('donante', new Immutable.List(action.Obj))
		case ACTION_ORGANISMOREG_NOTIFICACION:
			return state.set('organismo', new Immutable.List(action.Obj))
		case ACTION_CONSULTOR_NOTIFICACION:
			return state.set('consultor', new Immutable.List(action.Obj))
		case ACTION_CORRIDA_NOTIFICACION:
			return state.set('corrida', new Immutable.List(action.Obj))
		case ACTION_GRUPO_NOTIFICACION:
			return state.set('grupo', new Immutable.List(action.Obj))
		case ACTION_ESTADODON_NOTIFICACION:
			return state.set('estado', new Immutable.List(action.Obj))
		case ACTION_CATALOGORES_NOTIFICACION:
			return state.set('catalogo', new Immutable.List(action.Obj))
		case ACTION_ESTAPP_NOTIFICACION:
			return state.set('estadoApp', new Immutable.List(action.Obj))
		case ACTION_ESTPAGO_NOTIFICACION:
			return state.set('estadoPago', new Immutable.List(action.Obj))
		case ACTION_IMPRIMIR_NOTIFICACION:
			return state.set('imprimir', new Immutable.Map(action.Obj))
		case ACTION_ENVIAR_NOTIFICACION:
			return state.set('enviar', new Immutable.Map(action.Obj))
		case ACTION_CORRIDAS_DONATARIA:
			return state.set('corridas', new Immutable.List(action.Obj))
		case ACTION_PRINT_NOTIFICATION:
			return state.set('Uid', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};


/* Action Creators */

export const tiposNotificacion = () => {

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/tiposNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_TIPOS_NOTIFICATION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}


export const plantillas = () => {

	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/plantillas',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_PLANTILLAS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const tiposEnvio = () => {
	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/tiposEnvio',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_TIPOS_ENVIO, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const donatariaNotificacion = () => {
	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donatariaNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_DONATARIA_NOTIFICACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}


export const donanteNotificacion = () => {
	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donanteNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_DONANTE_NOTIFICACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const organismoregNotificacion = () => {
	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/organismoregNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_ORGANISMOREG_NOTIFICACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const consultorNotificacion = () => {
	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/consultorNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_CONSULTOR_NOTIFICACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const corridaNotificacion = () => {

	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/corridaNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_CORRIDA_NOTIFICACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const grupoNotificacion = () => {
	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/grupoNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GRUPO_NOTIFICACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const estadodonNotificacion = () => {
	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/estadodonNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_ESTADODON_NOTIFICACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const catalogoresNotificacion = () => {
	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/catalogoresNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_CATALOGORES_NOTIFICACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const estappNotificacion = () => {
	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/estappNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_ESTAPP_NOTIFICACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const estpagoNotificacion = () => {

	return (dispatch) =>{
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/estpagoNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_ESTPAGO_NOTIFICACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const imprimirNotificacion = (form/* ,option */) => {

	const tmp = {
		asunto: form.asunto || null,
		catalogoResultadosSelected: form.catalogoSelected || null,
		consultorSelected: form.masiveFilter.selected.consultorSelected ? form.masiveFilter.selected.consultorSelected : form.individualFilter.consultorSelected ? form.individualFilter.consultorSelected: false,
		cuerpo: form.cuerpoDeTexto || null,
		declaracion: form.declaracion || null,
		donanteSelected: form.masiveFilter.selected.donanteSelected ? form.masiveFilter.selected.donanteSelected : form.individualFilter.donanteSelected ? form.individualFilter.donanteSelected: false,
		donatariaSelected: form.masiveFilter.selected.donatariaSelected ? form.masiveFilter.selected.donatariaSelected : form.individualFilter.donatariaSelected ? form.individualFilter.donatariaSelected : false,
		estatusAplicacionDelDonativoSelected: form.estatusAppSelected || null,
		estatusDonatariaSelected: form.estatusDonatariaSelected || null,
		estatusPagoSelected: form.estPagoSelected || null,
		figuraJuridicaSelected: form.figuraSelected || null,
		idCatalogoResultados: form.masiveFilter.filterOne.catalogoResultados || null,
		idConsultorSelected: form.individualFilter.Consultor || null,
		idCorrida: form.masiveFilter.Corrida ? form.masiveFilter.Corrida : form.individualFilter.corridasDeLaDonataria ? form.individualFilter.corridasDeLaDonataria : null,
		idDonanteSelected: form.individualFilter.Donante || null,
		idDonatariaSelected: form.individualFilter.donataria || null,
		idEstatusAplicacionDelDonativo: form.masiveFilter.filterOne.estAplnDonativo || null,
		idEstatusDonataria: form.masiveFilter.filterOne.EstatusDonataria || null,
		idEstatusPago: form.masiveFilter.filterOne.estPago || null,
		idFiguraJuridica: form.masiveFilter.filterOne.figuraJuridica || null,
		idGrupo: form.masiveFilter.Grupo || null,
		idOrganoReguladorSelected: form.individualFilter.OrgRegulador || null,
		idOtroActorSelected: form.individualFilter.Otros || null,
		idPlantillaCarta: form.Plantilla || null,
		idProgramaAsociado: form.valueSelected || null,
		idTipoEvio: form.TipoDeEnvio || null,
		idTipoNotificacion: form.TipoDeNotificacion || null,
		dropBoxIds: form.documents.map((d) => {return d.documento.idDocumento}),
		organoReguladorSelected: form.masiveFilter.selected.OrgReguladorSelected ? form.masiveFilter.selected.OrgReguladorSelected : form.individualFilter.OrgReguladorSelected ? form.individualFilter.OrgReguladorSelected : false,
		otrosActoresSelected: form.masiveFilter.selected.otrosSelected ? form.masiveFilter.selected.otrosSelected : form.individualFilter.otrosSelected ? form.individualFilter.otrosSelected : false ,
		programaAsociadoSelected: form.progAsociadoSelected || null,
		showCorridas: form.corridaSelected || null,
		showGrupos: form.grupoSelected,
		todoElUniverso: false
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/imprimirNotificacion',
			method: 'POST',
			data: {...tmp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.iud})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({type:ACTION_PRINT_NOTIFICATION, Obj:response.data})
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			return error
		})
	}
}

export const enviarNotificacion = (form/* ,option */) => {

	const tmp = {
		asunto: form.asunto || null,
		catalogoResultadosSelected: form.catalogoSelected || null,
		consultorSelected: form.masiveFilter.selected.consultorSelected ? form.masiveFilter.selected.consultorSelected : form.individualFilter.consultorSelected ? form.individualFilter.consultorSelected: false,
		cuerpo: form.cuerpoDeTexto || null,
		declaracion: form.declaracion || null,
		donanteSelected: form.masiveFilter.selected.donanteSelected ? form.masiveFilter.selected.donanteSelected : form.individualFilter.donanteSelected ? form.individualFilter.donanteSelected: false,
		donatariaSelected: form.masiveFilter.selected.donatariaSelected ? form.masiveFilter.selected.donatariaSelected : form.individualFilter.donatariaSelected ? form.individualFilter.donatariaSelected : false,
		estatusAplicacionDelDonativoSelected: form.estatusAppSelected || null,
		estatusDonatariaSelected: form.estatusDonatariaSelected || null,
		estatusPagoSelected: form.estPagoSelected || null,
		figuraJuridicaSelected: form.figuraSelected || null,
		idCatalogoResultados: form.masiveFilter.filterOne.catalogoResultados || null,
		idConsultorSelected: form.individualFilter.Consultor || null,
		idCorrida: form.masiveFilter.Corrida ? form.masiveFilter.Corrida : form.individualFilter.corridasDeLaDonataria ? form.individualFilter.corridasDeLaDonataria : null,
		idDonanteSelected: form.individualFilter.Donante || null,
		idDonatariaSelected: form.individualFilter.donataria || null,
		idEstatusAplicacionDelDonativo: form.masiveFilter.filterOne.estAplnDonativo || null,
		idEstatusDonataria: form.masiveFilter.filterOne.EstatusDonataria || null,
		idEstatusPago: form.masiveFilter.filterOne.estPago || null,
		idFiguraJuridica: form.masiveFilter.filterOne.figuraJuridica || null,
		idGrupo: form.masiveFilter.Grupo || null,
		idOrganoReguladorSelected: form.individualFilter.OrgRegulador || null,
		idOtroActorSelected: form.individualFilter.Otros || null,
		idPlantillaCarta: form.Plantilla || null,
		idProgramaAsociado: form.valueSelected || null,
		idTipoEvio: form.TipoDeEnvio || null,
		idTipoNotificacion: form.TipoDeNotificacion || null,
		dropBoxIds: form.documents.map((d) => {return d.documento.idDocumento}),
		organoReguladorSelected: form.masiveFilter.selected.OrgReguladorSelected ? form.masiveFilter.selected.OrgReguladorSelected : form.individualFilter.OrgReguladorSelected ? form.individualFilter.OrgReguladorSelected : false,
		otrosActoresSelected: form.masiveFilter.selected.otrosSelected ? form.masiveFilter.selected.otrosSelected : form.individualFilter.otrosSelected ? form.individualFilter.otrosSelected : false ,
		programaAsociadoSelected: form.progAsociadoSelected || null,
		showCorridas: form.corridaSelected || null,
		showGrupos: form.grupoSelected,
		todoElUniverso: false
	}

	return (dispatch) =>{

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/enviarNotificacion',
			method: 'POST',
			data: {...tmp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.iud})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({type:ACTION_ENVIAR_NOTIFICACION, Obj:response.data})
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			return error
		})
	}
}

export const corridasDonatariaNotification = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/corridasDonatariaNotification',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({type: ACTION_CORRIDAS_DONATARIA, Obj: response.data})
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Notifications/Notifications.js